/**
 * 🎯 ENRUTADOR PRINCIPAL DE LA APLICACIÓN
 * 
 * Estructura de URLs:
 * - / → Landing Page
 * - /login → Página de inicio de sesión
 * - /register → Página de registro
 * - /forgot-password → Recuperación de contraseña
 * - /reset-password?token=... → Restablecer contraseña con token del email
 * - /pricing → Selección de planes (pública)
 * - /universal → Energía universal del día (pública, sin login)
 * - /app → Aplicación principal (requiere autenticación)
 */

import { Routes, Route, Navigate } from 'react-router-dom';

// Páginas
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import PricingPage from './pages/PricingPage';
import AppPage from './pages/AppPage';
import CompletePurchasePage from './pages/CompletePurchasePage';
import UniversalPage from './pages/UniversalPage';

// Componentes
import ProtectedRoute from './components/ProtectedRoute';
import TrialSignupPage from './pages/TrialSignupPage';
import TrialStartPage from './pages/TrialStartPage';
import TrialStatusPage from './pages/TrialStatusPage';

export default function App() {
  return (
    <Routes>
      {/* Página principal (Landing) */}
      <Route path="/" element={<LandingPage />} />
      
      {/* Autenticación */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      
      <Route path="/trial" element={<TrialSignupPage />} />
      <Route path="/trial/start" element={<ProtectedRoute><TrialStartPage /></ProtectedRoute>} />
      <Route path="/trial/status" element={<ProtectedRoute><TrialStatusPage /></ProtectedRoute>} />

      {/* Planes (pública - se puede ver sin autenticación) */}
      <Route path="/pricing" element={<PricingPage />} />

      {/* Energía Universal (pública - sin autenticación) */}
      <Route path="/universal" element={<UniversalPage />} />
      
      {/* Completa tu Pago (requiere autenticación) */}
      <Route
        path="/complete-purchase"
        element={
          <ProtectedRoute>
            <CompletePurchasePage />
          </ProtectedRoute>
        }
      />
      
      {/* Aplicación principal (protegida) */}
      <Route 
        path="/app" 
        element={
          <ProtectedRoute>
            <AppPage />
          </ProtectedRoute>
        } 
      />
      
      {/* Redirigir cualquier ruta desconocida al inicio */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
